//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SubMenuContainer from './Shared/SubMenuContainer.vue'
import SubMenuBasicItem from './Shared/SubMenuBasicItem.vue'
export default {
  components: {
    SubMenuContainer,
    SubMenuBasicItem,
  },
  props: {
    elements: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentPathItemId() {
      const path = this.$nuxt.$route.path
      const item = [...this.elements].find((item) => path.includes(item.path))
      return item ? item.id : null
    },
  },
  methods: {
    handleClick() {
      this.$emit('close-submenu')
      this.$store.commit('closeMenuMobile')
    },
  },
}
